import { Component, OnInit, Inject} from '@angular/core';
import { Ship } from '@classes/ship';
import { ShipService } from 'app/core/services/ship.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-ship-detail',
  templateUrl: './ship-detail.component.html',
  styleUrls: ['./ship-detail.component.scss']
})
export class ShipDetailComponent implements OnInit {

  shipForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ShipDetailComponent>,
    private shipService: ShipService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: Ship
  ) { }

  ngOnInit() {
    this.initFormBuilder();
  }
  private initFormBuilder() {
    const fb = this.formBuilder;
    const shipForm = this.shipForm = fb.group({
      id: fb.control(this.data?.id),
      name: fb.control(this.data?.name, [Validators.required, Validators.maxLength(150)]),
      eni: fb.control(this.data?.eni, [Validators.required, Validators.maxLength(10)]),
    });
  }
  onSubmit() {
    const ship = new Ship(
      this.shipForm.value
    )
    this.uiService.addRouteLoading();
    this.shipService.createOrUpdateShip(ship).subscribe(data => {
      this.dialogRef.close({
        success: true,
        data
      });
      this.uiService.displayMessageToast('ship.success-edit');
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
